module.exports = __webpack_public_path__ + "static/financesonline-6ca60a963a0205c5e6787f6e8e7abb43.png";